<!--能耗排名-->
<template>
	<div class="ecramkBody">
		<div class="ecramk_top">
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="能耗类型">
					<el-select v-model="form.type" placeholder="请选择活动区域">
						<el-option label="水" value="water"></el-option>
						<el-option label="电" value="electricity"></el-option>
						<el-option label="气" value="gas"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间">
					<el-date-picker v-model="form.dataTime" type="date" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label-width="10px">
					<el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="ecramk_bottom">
			<div class="ecramk_bottom_left">
				<vchart ref="vchart1"></vchart>
			</div>
			<div class="ecramk_bottom_rigth">
				<h1>分项用能排行</h1>
				<el-table :data="rankingTable" :default-sort="{order:'descending',prop: 'power'}">
					<el-table-column type="index" label="排行" width="120">
					</el-table-column>
					<el-table-column prop="type" label="类型">
					</el-table-column>
					<el-table-column prop="power" label="用电量">
						 <template slot-scope="scope">{{scope.row.power}}{{unit}}</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>
<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart,
		},
		props: {},
		data() {
			return {
				form: {
					type: "电",
					dataTime:new Date()
				},
				appType:36,
				unit:"Kwh",
				energyVariableList: [],
				rankingTable: [],
				option1: {
					series: [{
						name: '漏斗图',
						type: 'funnel',
						left: '10%',
						top: 60,
						bottom: 60,
						width: '80%',
						min: 0,
						max: 100,
						minSize: '0%',
						maxSize: '100%',
						sort: 'descending',
						gap: 2,
						label: {
							show: true,
							position: 'inside'
						},
						labelLine: {
							length: 10,
							lineStyle: {
								width: 1,
								type: 'solid'
							}
						},
						itemStyle: {
							borderColor: '#fff',
							borderWidth: 1
						},
						emphasis: {
							label: {
								fontSize: 20
							}
						},
						data: []
					}]
				}
			}
		},
		created() {},
		mounted() {
			this.$refs.vchart1.setData(this.option1)
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
		},
		watch: {
			'form.type': {
				deep: true,
				handler(nv, ov) {
					switch(nv) {
						case "电":
							this.unit = "Kwh"
							this.appType = 36
							break;
						case "水":
							this.unit = "m³"
							this.appType = 237
							break;
						case "气":
							this.unit = "Nm³"
							this.appType = 361
							break;
					}
				}
			},
		},
		methods: {
			onSubmit(){
				this.$api.areausePower.getRanking(this.nowUnit.id, this.appType,this.form.dataTime.getTime(),respon=>{
					this.option1.series[0].data=[]
					this.rankingTable=[]
					for(let key in respon.data){
						this.option1.series[0].data.push({name:key,value:respon.data[key]})
						this.rankingTable.push({type:key,power:respon.data[key]})
					}
					this.$refs.vchart1.setData(this.option1)
				})
			},
		}
	}
</script>

<style scoped>
	.ecramkBody {
		width: 100%;
		height: 100%;
		background-color: #11173c;
	}
	
	.ecramkBody .ecramk_top {
		width: 100%;
		height: 8%;
		display: flex;
		align-items: center;
	}
	
	.ecramkBody .ecramk_bottom {
		width: 100%;
		height: 92%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.ecramkBody .ecramk_bottom_left {
		width: 40%;
		height: 100%;
	}
	
	.ecramkBody .ecramk_bottom_rigth {
		width: 55%;
		height: 100%;
	}
	.ecramkBody .ecramk_bottom_rigth h1{
		font-size: .18rem;
		line-height: .4rem;
		color: white;
	}
</style>
<style>
	.ecramkBody .el-form-item {
		margin-bottom: 0;
		margin-left: .2rem;
	}
	
	.ecramkBody .el-form {
		display: flex;
	}
	.ecramkBody .el-form label{
		color: white;
	}
	.ecramk_bottom_rigth .el-table{
		 width: 90%;
		 background-color: #11173c;
	}
	.ecramk_bottom_rigth .el-table th {
		background-color: #082d76;
		color: white;
		border: 0;
	}
	
	.ecramk_bottom_rigth .el-table th:nth-child(1) {
		color: #0aa4e9;
	}
	
	.ecramk_bottom_rigth .el-table td {
		background-color: #11173c;
		color: white;
		border: 0;
		border-top: .01rem solid #0774af;
	}
	
	.ecramk_bottom_rigth .el-table td:nth-child(1) {
		color: #0aa4e9;
	}
	
	.ecramk_bottom_rigth .el-table tr:hover>td {
		background-color: #00456b;
	}
	.ecramk_bottom_rigth .el-table__body .el-table__row.hover-row td {
		background-color: #00456b !important;
	}
	.ecramk_bottom_rigth .el-table::before{
		background-color: #00456b;
	}
	/*表单样式*/
	.ecramkBody .el-input__inner{
		background-color: #11173c;
		border: 1px solid #0775a5;
		color: white;
	}
	.ecramkBody .el-radio-group {
		margin-left: .2rem;
		background-color: #11173c;
	}
	.ecramkBody .el-radio-button__inner{
		background-color: #11173c;
		border: 1px solid #0775a5;
		color: white;
	}
	.ecramkBody .el-radio-button:first-child .el-radio-button__inner{
		border-left: 1px solid #0775a5;
	}
</style>